module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.07abba5b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.woff
// module id = 361
// module chunks = 3